import React from 'react';
import { Modal, Typography } from 'antd';

const { Text } = Typography;

const HobbyModal = ({ isModalOpen, setIsModalOpen }) => {
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div style={{ pointerEvents: 'auto' }}>
      <div onClick={(e) => e.stopPropagation()}>
        <Modal
          centered
          open={isModalOpen}
          footer={null}
          onCancel={handleCancel}
          width={{
            xs: '90%',
            sm: '80%',
            md: '70%',
            lg: '60%',
            xl: '50%',
            xxl: '40%',
          }}
        >
          <Text>
          <br />
          <br />
            I've been an Arsenal fan for as long as I can remember. I've seen great moments and tough ones, but nothing felt quite like this year when Declan Rice scored his second free-kick against Real Madrid in the UEFA Champions League. That goal was special, the way he struck the ball, I could not believe it. It instantly became my favourite moment in an Arsenal shirt. It gave me the feeling that Arsenal were truly back at the top level.
            <br />
            <br />
            I love playing video games in my spare time. It's one of my favourite ways to relax and have fun. Some of the games I enjoy the most are FIFA, Overwatch, Rocket League, and Halo.
          </Text>
        </Modal>
      </div>
    </div>
  );
};

export default HobbyModal;